import angular from 'angular';
import gettext from 'angular-gettext';
import toastr from 'angular-toastr';
import PageResource from '../../cmsCore/PagesModules/PageResource';
import deleteElementDialog from '../../cmsCore/DeleteElementModal/deleteElement';
import FindFormService from './Services/FindFormService';

let pageFormDataPage = angular.module('cms.page.form.data', [
        PageResource,
        gettext,
        toastr,
        deleteElementDialog,
        FindFormService
    ]
).component('pageFormDataPage', {
    template: require('./templates/pageFormData.html'),
    controller: function (
        PageResource,
        $state,
        $stateParams,
        toastr,
        gettextCatalog,
        ACLService,
        deleteElementDialog,
        FindFormService
    ) {


        if ($stateParams.id) {
            PageResource.findFormDataDetails({id: $stateParams.id},
                response => {
                    this.formData = response;
                    this.form = FindFormService.findForm(this.formData.page.content);
                    this.formData.createdAt = (new Date(this.formData.createdAt)).toLocaleString();
                }
            );
        }

        this.matchRoles = ACLService.matchRoles;

        this.errors = {};
        this.pending = false;


        this.confirmDelete = () => {
            let removeMessage = gettextCatalog.getString("Are you sure that you want to delete this form data?");
            deleteElementDialog.open(removeMessage).then(() => {
                this.delete();
            }).catch(() => {
            });
        };

        this.delete = () => {
            this.pending = true;
            PageResource
                .deleteFormData({id: this.formData.id}, () => {
                    toastr.success(
                        gettextCatalog.getString('Form data deleted!'),
                        gettextCatalog.getString('Success')
                    );
                    this.goToList();
                    this.pending = false;
                })
        };

        this.cancel = () => this.goToList();

        this.goToList = () => {
            $state.go('pageFormDataList', {id: this.formData.page.id})
        };

        this.isSimpleField = (type) =>
            [
                'formText',
                'formTextarea',
                'formEmail',
                'formNumber'
            ].indexOf(type) > -1


    }
});

export default pageFormDataPage.name;




// WEBPACK FOOTER //
// ./src/cmsPages/Pages/PageFormDataPage.js